import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AppContext';
import { portalPathForRole } from '../navigation/paths';
import { isPortalAccessGranted } from '../utils/historySession';
import Logo from '../components/ui/Logo';

/**
 * Giriş yapmış kullanıcıyı login sayfasından portala yönlendirir.
 * Firebase oturumu olup profil yüklü değilse (ana sayfaya dönüş, hata) LoginScreen açılır;
 * oturumu SMS/kod istemeden sürdürme orada yapılır, burada beklenirse sonsuz döner.
 */
const GuestOnlyRoute = ({ children }) => {
  const { loggedInUser, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-6 bg-slate-50 dark:bg-slate-900">
        <Logo size={56} variant="nav" />
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-emerald-600 border-t-transparent" />
      </div>
    );
  }

  if (loggedInUser && isPortalAccessGranted(loggedInUser.id)) {
    return <Navigate to={portalPathForRole(loggedInUser.role)} replace />;
  }

  return children;
};

export default GuestOnlyRoute;
